import { jsx as _jsx } from "react/jsx-runtime";
import { Toaster as SonnerToaster } from 'sonner';
import { useHasBottomBar } from '../../../lib/bottom-bar-presence';
/** Distanze di sonner dal bordo della viewport (desktop e mobile). */
const VIEWPORT_OFFSET_PX = 24;
const MOBILE_VIEWPORT_OFFSET_PX = 16;
/** Altezza del `FormFooter`: bordo + `py-3` + bottone `h-9`, arrotondata. */
export const FORM_FOOTER_CLEARANCE_PX = 64;
/**
 * Il `Toaster` di sonner delle app. Finché un pannello mostra il suo footer
 * (`FormFooter`) i toast salgono sopra il footer: in basso a destra
 * coprivano «Chiudi» e «Salva». Le altre distanze restano quelle di sonner.
 */
export function Toaster(props) {
    const hasBottomBar = useHasBottomBar();
    const clearance = hasBottomBar ? FORM_FOOTER_CLEARANCE_PX : 0;
    return (_jsx(SonnerToaster, { ...props, offset: { bottom: VIEWPORT_OFFSET_PX + clearance }, mobileOffset: { bottom: MOBILE_VIEWPORT_OFFSET_PX + clearance } }));
}
//# sourceMappingURL=index.js.map